export const WEEKLY_NOTIFICATION_EMAILS = "WEEKLY_NOTIFICATION_EMAILS";

const initialState = null; 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case WEEKLY_NOTIFICATION_EMAILS:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "weeklyNotificationEmails";

const storeMapping = {[storeName]: reducer};

export const weeklyNotificationEmailsSelector = (state) => state[storeName];

export default storeMapping;
